import type { TrackingEventName } from '~/shared/tracking/job-architecture-tracking-events';

export const trackableEvents: readonly TrackingEventName[] = [
    'ai-action-used',
    'architecture-search-executed',
    'changelog-opened',
    'chat-starter-prompt',
    'job-architecture-deleted',
    'job-role-exported',
    'job-role-version-saved',
    'job-role-workflow-transition',
    'page-view',
    'profile-task-interaction',
    'role-skill-change',
    'settings-changed',
];
